import { MembershipManager } from "@/components/shared/membership";
import { microAppMembershipService } from "@/lib/services";
import type { RoleOption } from "@/types";

const ROLE_OPTIONS: RoleOption[] = [
  { value: "admin", label: "Admin", description: "Edit + manage access" },
  { value: "editor", label: "Editor", description: "Edit metadata" },
  { value: "viewer", label: "Viewer", description: "Open + view" },
];

/** Membership access management for a micro app. */
export function MicroAppAccessTab({ appUuid }: Readonly<{ appUuid: string }>) {
  return (
    <MembershipManager
      service={microAppMembershipService}
      entityUuid={appUuid}
      roleOptions={ROLE_OPTIONS}
      description="Admins can edit the app and manage access. Editors can edit its metadata. Viewers can open it."
      loadErrorLabel="Failed to load micro app access"
      listScrollClass="max-h-64 overflow-y-auto"
    />
  );
}
